import { Typography, Card, CardContent } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { IconBulb } from "@tabler/icons-react";

export default function NoDataAvailableState() {
  return (
    <Card>
      <CardContent className="al-py-16">
        <Stack direction="column" align="center" justify="center" gap="md">
          <div className="al-rounded-full al-bg-blue-50 al-p-4">
            <IconBulb className="al-w-8 al-h-8 al-text-blue-600" />
          </div>
          <Stack direction="column" align="center" gap="xs">
            <Typography variant="h4" weight="semibold">
              No data available
            </Typography>
            <Typography variant="body" size="sm" className="al-text-muted-foreground al-text-center">
              Upload a document to see learnings here
            </Typography>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
